module.exports = __webpack_public_path__ + "static/img/bg_card_pink@2x.955e511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/bg_card_pink@2x.png
// module id = l4S5
// module chunks = 0